import { Button, Flex, Text } from '@mantine/core'
import { memo } from 'react'

import { useTranslation } from '@flecto/translations'

type FiltersFooterProps = {
  handleClearAllFilters: () => void
  handleApplyFilters: () => void
  isLoading: boolean
  hasUnappliedChanges: boolean
  isClearAllEnabled: boolean
}

export function FiltersFooter({
  handleClearAllFilters,
  handleApplyFilters,
  isClearAllEnabled,
  hasUnappliedChanges,
  isLoading,
}: Readonly<FiltersFooterProps>) {
  const { t } = useTranslation('shared', { keyPrefix: 'filters' })
  return (
    <Flex
      data-testid='footer'
      component='footer'
      direction='column'
      p='sm'
      ta='center'
      pb={0}
    >
      <Flex gap='sm' data-testid='footer-buttons'>
        <Button
          onClick={handleClearAllFilters}
          data-testid='clear-all-button'
          disabled={!isClearAllEnabled}
          variant='outline'
          color='gray'
          size='sm'
          fullWidth
          style={{
            border: `1px solid ${isClearAllEnabled ? 'var(--mantine-color-gray-3)' : 'transparent'}`,
            fontSize: '0.875rem',
          }}
        >
          {t('footer.clear_all')}
        </Button>
        <Button
          disabled={!hasUnappliedChanges}
          onClick={handleApplyFilters}
          loading={isLoading}
          variant='primary'
          size='sm'
          fullWidth
          style={{
            fontSize: '0.875rem',
          }}
          data-testid='apply-button'
        >
          {t('footer.apply')}
        </Button>
      </Flex>
    </Flex>
  )
}
